import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { store, persistor } from "./redux/store";
import "./index.css";
import "./theme/overwrites.css";
import App from "./App";
import { PersistGate } from "redux-persist/integration/react";
import { registerServiceWorker } from "./service-worker-registration";
import { requestPersistentStorage } from "./utils/persistent-storage";
import "framework7/css";
import "framework7/components/dialog/css";
import "framework7/components/popup/css";
import "framework7/components/sheet/css";
import "framework7/components/toast/css";
import "framework7/components/preloader/css";
import "framework7/components/progressbar/css";
import "framework7/components/swipeout/css";
import "framework7/components/tabs/css";
import "framework7/components/panel/css";
import "framework7/components/input/css";
import "framework7/components/checkbox/css";
import "framework7/components/chip/css";
import "framework7/components/toggle/css";
import "framework7/components/pull-to-refresh/css";
import "framework7/components/fab/css";
import "framework7/components/swiper/css";
import "framework7/components/skeleton/css";
import "framework7/components/typography/css";

const root = ReactDOM.createRoot(document.getElementById("root"));
// Framework7 React does not survive StrictMode's double mount in development.
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
);

registerServiceWorker();
requestPersistentStorage();
